import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import SuccessImg from '../../../../Assets/Images/EsignGatewaySuccess.svg';
import RejectedImgIcon from '../../../../Assets/Images/EsignGatewayReject.svg';
import './success-modal.css';

function SuccessModal({
	open,
	onClose,
	showImage,
	message,
	subMessage,
	recipients,
	btnText,
	children,
	rejectImage
}) {
	return (
		<Modal open={open || false} onClose={() => {}} className='modal-container'>
			<Box className='modal-content'>
				{showImage ? (
					<Box
						component={'img'}
						className='success-image'
						src={rejectImage ? RejectedImgIcon : SuccessImg}
						alt='Half-In, Half-Out Image'
					/>
				) : null}

				{message ? (
					<h1 id='modal-message' className='medium3'>
						{message}
					</h1>
				) : (
					<h1 id='modal-title'>{rejectImage ? 'Rejected' : 'Successful !'}</h1>
				)}

				{subMessage ? (
					<h3 id='modal-sub-message' className='medium5'>
						{subMessage}
					</h3>
				) : (
					<h3 id='modal-sub-message' className='medium5'>
						Documents has been successfully sent to following recipients
					</h3>
				)}

				{recipients ? (
					<div id='modal-recipients' className='medium5'>
						<h3 id='modal-recipients-headng' className='medium7'>
							Recipients
						</h3>
						{recipients.map((recipient, index) => (
							<div key={'a' + index}>
								<span id='modal-recipient-name' className='medium7'>
									{recipient.firstName}
								</span>
								<br />
								<span id='modal-recipient-email' className='medium8'>
									{recipient.email}
								</span>
							</div>
						))}
					</div>
				) : null}
				{children}

				<Button
					variant='contained'
					id='modal-btn'
					fullWidth
					onClick={onClose}
					sx={{
						height: '40px',
						padding: '17px 20px',
						borderRadius: '8px',
						backgroundColor: rejectImage ? '#E96666' : '#b6d423',
						color: '#000',
						boxShadow: 'none',
						marginTop: '20px',
						fontSize: '16px',
						'&:hover': {
							backgroundColor: rejectImage ? '#E96666' : '#b6d423',
							boxShadow: 'none'
						}
					}}
				>
					<div className='medium5'>{btnText || 'Done'}</div>
				</Button>
			</Box>
		</Modal>
	);
}

export default SuccessModal;

SuccessModal.propTypes = {
	open: PropTypes.any,
	onClose: PropTypes.any,
	showImage: PropTypes.any,
	message: PropTypes.any,
	subMessage: PropTypes.any,
	recipients: PropTypes.any,
	btnText: PropTypes.any,
	children: PropTypes.any,
	rejectImage: PropTypes.any
};
